var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"remark"},[_c('el-tooltip',{attrs:{"effect":"dark","placement":"bottom-start","content":_vm._column.remark?_vm._column.remark:'-'}},[_c('span',{attrs:{"element":"name"}},[_vm._v(" "+_vm._s(_vm._column.remark?_vm._column.remark:"-")+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }